export class Conflict {}
